import axios from 'axios'
import store from '@/state/store'
import { validateExpireAccessToken } from '@/helpers/utils/jwt'
import { eventBus } from '@/main.js'
import Vue from 'vue'

const request = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  headers: {
    'Content-Type': 'application/json',
  },
})

request.interceptors.request.use(
  async request => {
    // eventBus.$emit('changeLoadingState', true)
    // if (request.url.includes('Authentications/signin')) {
    //   return request
    // } else {
      const accessToken = store.getters['auth/GET_ACCESS_TOKEN']
      if (validateExpireAccessToken(accessToken))
        request.headers.Authorization = 'Bearer ' + accessToken
    //}

    return request
  },
  error => {
    eventBus.$emit('changeLoadingState', false)
    
    eventBus.$emit('internalServerError', error.response)
    return Promise.reject(error)
  }
)

request.interceptors.response.use(
  response => {
    eventBus.$emit('changeLoadingState', false)
    return response
  },
  error => {
    eventBus.$emit('changeLoadingState', false)
    if (error.response) {
      switch (error.response.status) {
        case 400:
          break
        case 401:
          // redirectLogin()
        case 403:
          break
        case 404:
          // window.location = "/404";
          break
        case 412:
          break
        case 500:
          eventBus.$emit('internalServerError', error.response)   
          window.location = "/pages/500"
          break
        default:
          console.log('Error')
      }
    }
    return Promise.reject(error.response)
  }
)

// const redirectLogin = () => {
//   window.location = "/authentication/signin";
// }

const core = {
  head(endpoint, data, config, loadingState = false) {
    eventBus.$emit('changeLoadingState', loadingState)
    const params = {
      params: data,
    }
    const newParams = Object.assign(params, config)
    return request.head(endpoint, newParams)
  },
  fetch(endpoint, data, config, loadingState = false) {
    eventBus.$emit('changeLoadingState', loadingState)
    const params = {
      params: data,
    }
    const newParams = Object.assign(params, config)
    return request.get(endpoint, newParams)
  },
  fetchWithBearer(endpoint, data, header, loadingState = false) {
    eventBus.$emit('changeLoadingState', loadingState)
    // request.headers.Authorization = `Bearer ${bearer}`;
    const params = {
      params: data,
    }
    const newParams = Object.assign(params)
    console.log('newParams', newParams)
    return request.get(endpoint, {newParams, header})
  },
  create(endpoint, data, config, loadingState = true) {
    eventBus.$emit('changeLoadingState', loadingState)
    return request.post(endpoint, data, config)
  },
  createWithBearer(endpoint, data, header, loadingState = true) {
    eventBus.$emit('changeLoadingState', loadingState)
    return request.post(endpoint, data, {
      headers: header
    })
  },

  upload(endpoint, data, loadingState = true) {
    eventBus.$emit('changeLoadingState', loadingState)
    const accessToken = Vue.$cookies.get('.oauth.at')
    return axios({
      method: 'post',
      processData: false,
      contentType: 'multipart/form-data',
      cache: false,
      url: endpoint,
      data: data,
      headers: {
        Authorization: 'Bearer ' + accessToken,
      },
    })
  },

  update(endpoint, data, config, loadingState = true) {
    eventBus.$emit('changeLoadingState', loadingState)
    return request.put(endpoint, data, config)
  },

  edit(endpoint, data, config, loadingState = true) {
    eventBus.$emit('changeLoadingState', loadingState)
    return request.patch(endpoint, data, config)
  },

  remove(endpoint, data, config, loadingState = true) {
    eventBus.$emit('changeLoadingState', loadingState)
    const params = { data }
    const newParams = Object.assign(params, config)
    return request.delete(endpoint, newParams)
  },

  delete(endpoint, id, config, loadingState = true) {
    eventBus.$emit('changeLoadingState', loadingState)
    const params = {
      params: {
        id,
      },
    }
    const newParams = Object.assign(params, config)
    return request.delete(endpoint, newParams)
  },
}

export default core
